import MySwitchField from "@components/form/switch";
import { RHFTextField } from "@components/hook-form";
import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import type { TTranslate } from "../../../../core/types";

interface IPECDestinationFieldsProps {
  translate: TTranslate;
}

export const PECDestinationFields = ({
  translate,
}: IPECDestinationFieldsProps) => {
  const { getValues } = useFormContext();
  const initialPec = Boolean(getValues("customerPECCode"));
  const initialDest = Boolean(getValues("customerDestinationCode"));
  const [showPec, setShowPec] = useState(initialPec);
  const [showDest, setShowDest] = useState(initialDest);

  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
        sx={{ display: "flex", alignItems: "flex-end" }}
      >
        <MySwitchField
          checked={showPec}
          label={
            <Typography variant="body2">
              {translate("add_pec_code")}
            </Typography>
          }
          onChange={() => setShowPec((p) => !p)}
          labelPlacement="end"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{ display: "flex", alignItems: "flex-end" }}
      >
        <MySwitchField
          checked={showDest}
          label={
            <Typography variant="body2">
              {translate("add_destination_code")}
            </Typography>
          }
          onChange={() => setShowDest((p) => !p)}
          labelPlacement="end"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        />
      </Grid>

      {showPec && (
        <Grid item xs={12} md={6}>
          <RHFTextField
            name="customerPECCode"
            label={translate("pec_code")}
            placeholder={translate("add_pec_code")}
            fullWidth
          />
        </Grid>
      )}
      {showDest && (
        <Grid item xs={12} md={6}>
          <RHFTextField
            name="customerDestinationCode"
            label={translate("destination_code")}
            placeholder={translate("add_destination_code")}
            fullWidth
          />
        </Grid>
      )}
    </>
  );
};
